import React from 'react';
import { Icon } from '@iconify/react';
import { useSet } from 'ccstate-react';
import FileIcon from './FileIcon';
import { navigateToFolder$, toggleFileSelection$, toggleFileStar$ } from '../commands/fileCommands';
import type { FileItem } from '../../common/schema/schemaType';
interface FileCardProps {
    file: FileItem;
    isSelected: boolean;
    onDoubleClick?: () => void;
    onRightClick?: (e: React.MouseEvent) => void;
}
export default function FileCard({ file, isSelected, onDoubleClick, onRightClick }: FileCardProps) {
    const navigateToFolder = useSet(navigateToFolder$);
    const toggleSelection = useSet(toggleFileSelection$);
    const toggleStar = useSet(toggleFileStar$);
    const formatFileSize = (bytes?: number) => {
        if (!bytes)
            return '';
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
    };
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };
    const handleClick = () => {
        toggleSelection(file.id);
    };
    const handleDoubleClick = () => {
        if (file.type === 'folder') {
            navigateToFolder(file.id);
        }
        onDoubleClick?.();
    };
    const handleStarClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        toggleStar(file.id, !file.isStarred);
    };
    const handleRightClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onRightClick?.(e);
    };
    return (<div className={`bg-white rounded-lg flex flex-col p-3 gap-3 cursor-pointer border transition-all ${isSelected
            ? 'border-[#4A90E2] bg-[#E8F2FC]'
            : 'border-transparent hover:bg-[#F0F4F8] hover:border-[#4A90E2]'}`} onClick={handleClick} onDoubleClick={handleDoubleClick} onContextMenu={handleRightClick} data-testid={`file-card-${file.id}`} data-id="krkdnq">
      {/* Thumbnail/Icon */}
      <div className="rounded-md w-full aspect-square bg-[#F0F4F8] flex items-center justify-center relative" data-id="p1clpn">
        <FileIcon file={file} size="lg" className="w-12 h-12 text-4xl" data-id="0x2ip7"/>

        {/* Star indicator */}
        {file.isStarred && (<button className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded hover:bg-white/80" onClick={handleStarClick} data-testid={`star-button-${file.id}`} data-id="8y1a68">
            <Icon icon="lucide:star" className="w-4 h-4 text-[#FB8C00] fill-current" data-id="hi8pa8"/>
          </button>)}

        {/* Shared indicator */}
        {file.isShared && (<div className="absolute top-2 left-2 w-6 h-6 flex items-center justify-center" data-id="01znns">
            <Icon icon="lucide:users" className="w-4 h-4 text-[#4A90E2]" data-id="2hf7am"/>
          </div>)}
      </div>

      {/* File info */}
      <div className="flex flex-col gap-1" data-id="bfbvna">
        <div className="text-sm font-semibold text-[#1A2B3D] truncate" title={file.name} data-id="qm90p9">
          {file.name}
        </div>
        <div className="text-xs text-[#8B99A8]" data-id="vgjx0r">
          {file.type === 'file' ? formatFileSize(file.size) : 'Folder'} • {formatDate(file.modifiedDate)}
        </div>
      </div>
    </div>);
}
